import axiosInstance from '../axiosInterceptor/axiosInstance'

// Owner-only. `documentHash` pins the document actually displayed. Answers 204.
const acceptOrgContract = (orgId, documentHash) =>
  axiosInstance
    .post(`v1/orgs/${orgId}/contracts/accept`, { documentHash }, { skipErrorNotification: true })
    .then((r) => r.data)

export default acceptOrgContract
